import { JSX } from 'react';
import { SwitchButton } from '@bg-components/SwitchButton';
import { ListItem } from '../ListItem';
import classes from './ToggleListItem.module.scss';

interface IProps {
    label: string;
    enabled: boolean;
    onChange(newValue: boolean): void;
    disabled?: boolean;
    dataQa?: string;
}

export const ToggleListItem = (props: IProps): JSX.Element => (
    <ListItem
        disabled={props.disabled}
        label={props.label}
        dataQa={props.dataQa}
        onClick={() => {
            props.onChange(!props.enabled);
        }}
    >
        <SwitchButton
            className={classes.checkbox}
            checked={props.enabled}
            onChange={() => {}}
            id={props.label}
            dataQa={props.dataQa}
        />
    </ListItem>
);
